import { useState } from "react";
import { Button, Modal, Nav } from "react-bootstrap";
import styles from "../../../colaborador/styles/colaborador.module.css";
import FormDownloadRelatorioFolhaPontoManual from "../DownloadRelatorioFolhaPonto";
import FormDownloadRelatorioPonto from "../DownloadRelatorioPonto";

export default function ConsultarModalDownloadRelatorio({ show, handleClose, apuracao }: iProps) {
    const [menu, setMenu] = useState<MenuItem[]>([
        {
            key: "folha_ponto",
            link: "link-0",
            visibled: true,
            display: "block",
        },
        {
            key: "folha_ponto_vazio",
            link: "link-1",
            visibled: false,
            display: "none",
        },
    ]);

    const handleMenuItemClick = (e: any) => {
        const index = Number(e.target.getAttribute("tabindex"));
        let menuItems = menu;

        if (e.ctrlKey) {
            let item: MenuItem = menuItems[index];
            item.display = item.display === "none" ? "block" : "none";
            item.visibled = item.visibled === false ? true : false;
            document.getElementById(item.key)!.style.display = item.display;
            if (item.visibled) {
                document.getElementById(item.link)!.classList.add("active");
            } else {
                document.getElementById(item.link)!.classList.remove("active");
            }
            menuItems[index] = item;
            setMenu(menuItems);
        } else {
            for (let i in menuItems) {
                if (Number(i) === index) {
                    let item: MenuItem = menuItems[index];
                    if (item.visibled) {
                        continue;
                    }
                    item.display = item.display === "none" ? "block" : "none";
                    item.visibled = item.visibled === false ? true : false;
                    document.getElementById(item.key)!.style.display = item.display;
                    if (item.visibled) {
                        document.getElementById(item.link)!.classList.add("active");
                    } else {
                        document.getElementById(item.link)!.classList.remove("active");
                    }
                    menuItems[index] = item;
                } else {
                    let item: MenuItem = menuItems[i];
                    item.display = "none";
                    item.visibled = false;
                    document.getElementById(item.key)!.style.display = item.display;
                    if (item.visibled) {
                        document.getElementById(item.link)!.classList.add("active");
                    } else {
                        document.getElementById(item.link)!.classList.remove("active");
                    }
                    menuItems[i] = item;
                }
            }
            setMenu(menuItems);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Download Relatórios</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Nav variant="tabs">
                    <Nav.Item>
                        <Nav.Link id="link-0" key={"link-0"} onClick={handleMenuItemClick} href="" tabIndex={0} active={menu[0].visibled} className={styles.linkTab}>
                            Folha de Ponto Registros
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link id="link-1" key={"link-1"} onClick={handleMenuItemClick} href="" tabIndex={1} active={menu[1].visibled} className={styles.linkTab}>
                            Folha de Ponto Manual
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
                <div id={menu[0].key} key={menu[0].key} style={{ display: menu[0].display }}>
                    <FormDownloadRelatorioPonto apuracao={apuracao} />
                </div>
                <div id={menu[1].key} key={menu[1].key} style={{ display: menu[1].display }}>
                    <FormDownloadRelatorioFolhaPontoManual apuracao={apuracao} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
interface iProps {
    show: boolean;
    handleClose: any;
    apuracao: any;
}
interface MenuItem {
    key: string;
    link: string;
    visibled: boolean;
    display: string;
}
